import { Component, OnInit, DoCheck, EventEmitter, Input, Output } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { AutoCompleteService } from "./autocomplete.service";

@Component({
    selector: 'autocomplete-component',
    template: require('./autocomplete.component.html')
})
export class AutoCompleteComponent implements OnInit, DoCheck {
    @Input() isRequired: boolean = true;
    @Input() isDisabled: boolean = false;
    @Input() isCreateNew: boolean = true;
    @Input() submitted: boolean = false;
    @Input() delay: boolean = false;
    @Input() clear: boolean = false;
    @Input() selectId: string;
    @Input() fieldToShow: string;
    @Input() placeholder: string = '— Selecione —';
    @Input() apiCustom: string = '/listar';
    @Input() label: string;
    @Input() method: string = 'POST';
    @Input() model: any;
    @Input() _service: any;
    @Input() query: any;
    @Input() templateResult: any;
    @Input() templateSelection: any;
    @Output() setObejct: EventEmitter<any> = new EventEmitter();
    @Output() clearObject: EventEmitter<any> = new EventEmitter();

    private terms: Array<string>;

    constructor(
        private _restService: RestService,
        private _autocompleteService: AutoCompleteService
    ){}

    ngOnInit() {
        if (this.fieldToShow) {
            this.terms = this.fieldToShow.split(",");
        }

        var select2:any;
        if (this.delay) {
            setTimeout(function() {
                select2 = $("#" + this.selectId + " select");
                this.createSelect2(select2);
            }.bind(this));
        } else {
            select2 = $("#" + this.selectId + " select");
            this.createSelect2(select2);
        }
    }

    ngDoCheck() {

    }

    private createSelect2(select2: any) {

        this.autocomplete(select2);

        select2.on('select2:select', function (evt: any) {
            this.onchangeSelect(evt);
        }.bind(this));

        select2.on('select2:open', function (evt: any) {
            this.onOpenSelect(evt);
        }.bind(this));

        select2.on('select2:unselect', function (evt: any) {
            this.clearObject.next({});
            select2.select2("close");
        }.bind(this));
    }

    private autocomplete(inputElement:any) {
        var route:string,
            Ajax:any;

        route = this._service.onGetApiUrl();

        Ajax = this._restService.getAutocompleteAjax(route, this.apiCustom, this.method);
        Ajax.data = this.processData;
        Ajax.processResults = this.processResults;
        var OptionsSelect2: any = {
            ajax: Ajax
        };

        this.createOption2(OptionsSelect2, inputElement);
    }

    private processOutResults(ResultObject: any, fieldShow: any) {
        var ObjectOut: any = {
            id: ResultObject.id
        };

        var text: string = "";
        var term1: string;
        var term2: string;
        var termSplit: Array<string>;

        for (let key in fieldShow) {
            termSplit = fieldShow[key].split(".");
            term1 = ResultObject;

            for (let keyY in termSplit) {
                term2 = term1[termSplit[keyY]];
                if (term2) {
                    term1 = term2;
                }
            }

            if (text && (key < fieldShow.length)) {
                text = text.concat(" / ");
            }
            text = text.concat(term1);
        }

        ObjectOut.text = text;

        return ObjectOut;
    }

    private createOption2(OptionsSelect2: any, inputElement: any) {
        if (this.templateResult) {
            OptionsSelect2.templateResult = this.templateResult;
            OptionsSelect2.templateSelection = this.templateResult;
        } else {
            OptionsSelect2.templateResult = this.templateList;
            OptionsSelect2.templateSelection = this.templateList;
        }

        if (this.placeholder) {
            OptionsSelect2.placeholder = this.placeholder;
        }

        if (this.clear) {
            OptionsSelect2.allowClear = true;
        }

        inputElement.select2(OptionsSelect2);
    }

    private processIn = (function(params: any) {
        if (!params.term) {
            params.term = '';
        }

        var newQuery: any = JSON.stringify(this.query);
        newQuery = newQuery.replace(/REPLACEHERE/g, params.term);
        newQuery = JSON.parse(newQuery);
        var ObjectIn: any = newQuery;

        return ObjectIn;
    }.bind(this));

    private processOut = (function (ResponseResultFind: any) {
        var processOutResults: any = this.processOutResults;
        var hasTemplate: any = this.templateResult;
        var ObjectOut: any;

        if (!hasTemplate) {
            ObjectOut = processOutResults(ResponseResultFind, this.terms);
        } else {
            ObjectOut = ResponseResultFind;
        }

        return ObjectOut;
    }.bind(this));

    private processData = (function (params: any) {
        var ObjectSend = this.processIn(params);
        var filter = JSON.stringify(ObjectSend);
        return filter;
    }.bind(this));

    private processResults = (function (ResultFind: any, Params: any) {
        var ResponseResultFind = ResultFind;

        Params.page = Params.page || 1;

        var Items: any[] = [];
        var indiceResult: any;
        var lengthResult: any;

        for (indiceResult = 0, lengthResult = ResponseResultFind.length; indiceResult < lengthResult; indiceResult++) {
            var Item = this.processOut(ResponseResultFind[indiceResult]);
            Items.push(Item);
        }

        var text: string = "";
        if (Params.term) {
            text = Params.term;
        }

        if (this.isCreateNew) {
            Items.push({id: -1, text: text});
        } else {
            if (Items.length === 0) {
                Items.push({id: -1, text: 'Nenhum item encontrado'});
            } else {
                Items.push({id: -1, text: ''});
            }
        }

        return {
            results: Items,
            pagination: {
                more: (Params.page * 30) < lengthResult
            }
        };
    }.bind(this));

    private onchangeSelect = (function($event: any) {
        if ($event.params) {
            var thisValue:any = $event.params.data;
            if (thisValue.id) {
                if (thisValue.id === -1) {
                    this.model = {novo: true, text: thisValue.text};
                } else {
                    if (this.templateResult) {
                        //se tiver um template result
                        this.model = thisValue;
                    } else {
                        //se for text/id
                        this.model = {id: thisValue.id, text: thisValue.text};
                    }
                }
            } else {
                this.model = null;
            }

            this.setObejct.next(this.model);
        }
    }.bind(this));

    private onOpenSelect = (function($event: any) {
        setTimeout(function () {
            var element:any = document.getElementById("select2-newElement");
            if (!element) {
                var div:any = document.createElement("DIV");
                div.id = "select2-newElement";
                $(".select2-results").append(div);
            }
        });

    }.bind(this));

    private templateList = (function(state: any) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (!this.isCreateNew) {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                } else {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                }
            } else {
                text = state.text;
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/components/autocomplete/autocomplete.component.ts
 **/